module.exports = __webpack_public_path__ + "static/media/crane-worldwide.cfb65e6e.png";